import ResourceConfig from './ResourceConfig';
import DirectoryConfig from './DirectoryConfig';

export default abstract class AssetConfig extends ResourceConfig {
  constructor(
    protected readonly configuration: object,
    protected readonly directoryConfiguration: DirectoryConfig
  ) {
    super(configuration);
  }

  public get(what: string): any {
    if (this.has(what)) {
      return (this.configuration as any)[what];
    }

    // look up to the directory config in case it's defined there
    return this.directory().get(what);
  }

  protected directory(): DirectoryConfig {
    return this.directoryConfiguration;
  }
}
